import { createFileRoute } from "@tanstack/react-router";

import { TransportsAdminPage } from "./_app.erp.settings.transports";

export const Route = createFileRoute("/_app/settings/transports")({
  component: TransportsAdminPage,
});
